export const selectNotifications = (state) => {
  return state.notifications.active
}
